import { v4 as uuidv4 } from 'uuid'
import { AxiosService } from './axios.service'
import { StorageService } from './storage.service'
import { dateHelper } from '../helpers/date.helper'

/**
 * Defines the API methods for the shopping cart
 */
export class CartService {
	static baseURL = 'carts'

	/**
	 * Creates a shopping cart on the MuviHub API and stores it, along with the
	 * session used to create it, in localStorage
	 * @param {Date|string} [returnDate] The return date, when the user is
	 * buying a round trip - omitted entirely for one-way purchases
	 * @return {Promise<any>} The created cart, including its id
	 */
	static createCart(returnDate) {
		const params = {
			currency: 'BRL',
			sessionId: `ses_${StorageService.useSessionId.get()}`
		}

		if (returnDate) {
			params.returnDate = dateHelper.formatToYYYYMMDD(returnDate)
		}

		return AxiosService.postMuviHub(CartService.baseURL, params).then(({ data }) => {
			const cart = data.data

			StorageService.cart.set({ ...cart, sessionId: params.sessionId })
			return cart
		})
	}

	/**
	 * Applies a discount coupon to the current cart
	 * @param {string} code The coupon code
	 * @param {string} cpf The buyer's CPF, required by the API to validate the coupon
	 * @return {Promise<any>} { success, message, data: <cart summary: coupon, totals, poltronas, ...> }
	 */
	static applyCoupon(code, cpf) {
		const cart = StorageService.cart.get()

		return AxiosService.postMuviHub(
			`${CartService.baseURL}/${cart && cart.id}/coupon`,
			{ code, cpf }
		).then(({ data }) => data)
	}

	/**
	 * Checks out the current cart, charging the given payment instrument
	 * @param {object} payload { payment, buyer, passengers, context }
	 * @return {Promise<any>} the checkout result
	 */
	static checkout(payload) {
		const cart = StorageService.cart.get()

		return AxiosService.postMuviHub(
			`${CartService.baseURL}/${cart && cart.id}/checkout`,
			payload,
			{ headers: { 'X-Idempotency-Key': uuidv4() } }
		).then(({ data }) => data)
	}
}
